import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';
import { AdminSidebar } from '@/components/layout/AdminSidebar';

// Authenticated admin chrome. Same gating contract as the previous Next
// layout — uses the zustand auth store, waits for hydration before rendering
// to avoid the post-refresh redirect race.
export default function AdminLayout() {
  const navigate = useNavigate();
  const { isAuthenticated, hasHydrated } = useAuthStore();

  useEffect(() => {
    if (hasHydrated && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, hasHydrated, navigate]);

  if (!hasHydrated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-gray-400 text-sm">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar />
      <main className="flex-1 ml-60">
        <Outlet />
      </main>
    </div>
  );
}
